import { Store } from "redux";
import { AlmeUIInput } from "@alme/ui-web/types/input";
import settings from "../../../settings/settings";

interface FPMLParameters {
    IsUserLoggedIn: {
        cookieName: string;
        sessionStorageKey: string;
    };
}
interface LoginSession {
    user: {
        isLoggedIn: boolean;
    };
}
interface InputParameters{
    [key: string]: unknown;
}

export default class UserSessionLogginRequestProcessor {
    private _settings: typeof settings;
    private _store: Store | undefined;

    constructor(passedSettings?: typeof settings) {
        this._settings = passedSettings || settings;
    }

    initialize(store: Store): void {
        this._store = store;
    }

    static getDefaultSettings(): typeof settings {
        return settings;
    }

    getRequestProcessor(): this {
        return this;
    }

    process(input: AlmeUIInput): AlmeUIInput {
        let inputParameters: InputParameters = {};
        if (input.parameters) {
            inputParameters = input.parameters ;
        }

        const FPMLParameters = this._settings.FPMLParameters as FPMLParameters;
        Object.keys(FPMLParameters).forEach(param => {
            const loginSession = window.sessionStorage.getItem(FPMLParameters.IsUserLoggedIn.sessionStorageKey) as string;
            const objLoginSession = JSON.parse(loginSession) as LoginSession;
            inputParameters[param] = objLoginSession?.user?.isLoggedIn ;

        });
        return Object.assign({}, input, { parameters: inputParameters });
    }
}


// WEBPACK FOOTER //
// ./components/request-processor-user-loggedin-session/src/request-processor-user-loggedin-session.ts